// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container--lY_Oc{width:100%;margin-top:var(--space-s)}", "",{"version":3,"sources":["webpack://./components/subscriptions/CardSelector/MobileCardSelector/CardSelector.module.scss"],"names":[],"mappings":"AAAA,kBACE,UAAA,CACA,yBAAA","sourcesContent":[".container {\n  width: 100%;\n  margin-top: var(--space-s);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container--lY_Oc"
};
export default ___CSS_LOADER_EXPORT___;
